export default function CheckMarkCircleIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.168 2.7816C12.9422 2.07256 11.5191 1.66675 10.0013 1.66675C5.39893 1.66675 1.66797 5.39771 1.66797 10.0001C1.66797 14.6024 5.39893 18.3334 10.0013 18.3334C14.6036 18.3334 18.3346 14.6024 18.3346 10.0001C18.3346 9.42933 18.2772 8.87191 18.168 8.33341"
        stroke="#0073FF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6.66797 10.4167C6.66797 10.4167 7.91797 10.4167 9.58464 13.3334C9.58464 13.3334 14.217 5.69452 18.3346 4.16675"
        stroke="#0073FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
